import { render, staticRenderFns } from "./ChartRpe.vue?vue&type=template&id=20f6e9c3&scoped=true&"
import script from "./ChartRpe.vue?vue&type=script&lang=js&"
export * from "./ChartRpe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6e9c3",
  null
  
)

export default component.exports